import React, { useState, useEffect } from "react";
import AccountSales from "../../reports/Sales/AccountSales";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "../../../header/header";
import Navvbar from "../../../header/Navvbar";
import axios from "axios";

const Addaccountsales = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const initialParams = location.state || {};

  const getDefaultDates = () => {
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    };

    return {
      startDate: formatDate(firstDay),
      endDate: formatDate(lastDay),
    };
  };

  const defaultDates = getDefaultDates();

  /*
   * Temporary dummy data.
   * Backend data will automatically replace this when available.
   */
  const dummyCases = [
    {
      invoiceNumber: "38249",
      caseNumber: "38249",
      caseId: "38249",
      account_name: "Adrian Popovici",
      provider_name: "Adrian Popovici",
      first_name: "KATHI",
      last_name: "FEN GIBBS",
      date: "2026-09-01",
      totalPrice: 165,
      status: "",
    },
    {
      invoiceNumber: "38247",
      caseNumber: "38247",
      caseId: "38247",
      account_name: "Adrian Popovici",
      provider_name: "Adrian Popovici",
      first_name: "Steven",
      last_name: "Smith",
      date: "2026-09-01",
      totalPrice: 185,
      status: "",
    },
    {
      invoiceNumber: "38257",
      caseNumber: "38257",
      caseId: "38257",
      account_name: "Alaska House Dental Practice",
      provider_name: "Amit Sharma",
      first_name: "",
      last_name: "Scan bodies",
      date: "2026-09-02",
      totalPrice: 0,
      status: "",
    },
    {
      invoiceNumber: "38259",
      caseNumber: "38259",
      caseId: "38259",
      account_name: "ALL SAINTS DENTAL",
      provider_name: "Ahmed Farooq",
      first_name: "Jeremiah",
      last_name: "Cooney",
      date: "2026-09-02",
      totalPrice: 0,
      status: "",
    },
    {
      invoiceNumber: "38289",
      caseNumber: "38289",
      caseId: "38289",
      account_name: "ALL SAINTS DENTAL",
      provider_name: "Ahmed Farooq",
      first_name: "Danielle",
      last_name: "Meredith",
      date: "2026-09-04",
      totalPrice: 10,
      status: "",
    },
    {
      invoiceNumber: "38337",
      caseNumber: "38337",
      caseId: "38337",
      account_name: "ALL SAINTS DENTAL",
      provider_name: "Ahmed Farooq",
      first_name: "Vincent",
      last_name: "Edwards",
      date: "2026-09-09",
      totalPrice: 259,
      status: "",
    },
    {
      invoiceNumber: "38335",
      caseNumber: "38335",
      caseId: "38335",
      account_name: "ALL SAINTS DENTAL",
      provider_name: "Ahmed Farooq",
      first_name: "Cecilia",
      last_name: "Chavez Cordero, Aida",
      date: "2026-09-09",
      totalPrice: 10,
      status: "",
    },
    {
      invoiceNumber: "38338",
      caseNumber: "38338",
      caseId: "38338",
      account_name: "ALL SAINTS DENTAL",
      provider_name: "Ahmed Farooq",
      first_name: "Stephens",
      last_name: "Patricia",
      date: "2026-09-09",
      totalPrice: 20,
      status: "",
    },
    {
      invoiceNumber: "38340",
      caseNumber: "38340",
      caseId: "38340",
      account_name: "Armley Dental Practice",
      provider_name: "Amir Nawaz",
      first_name: "",
      last_name: "Dental Services",
      date: "2026-09-10",
      totalPrice: 10,
      status: "",
    },
  ];

  const [showParam, setShowParam] = useState(false);
  const [accounts, setAccounts] = useState([]);

  const [cases, setCases] = useState(
    initialParams.cases && initialParams.cases.length > 0
      ? initialParams.cases
      : dummyCases
  );

  const [loading, setLoading] = useState(true);

  const [params, setParams] = useState({
    current_start_date:
      initialParams.selectedDate ||
      initialParams.current_start_date ||
      defaultDates.startDate,

    current_end_date:
      initialParams.selectedDate ||
      initialParams.current_end_date ||
      defaultDates.endDate,

    accounts: initialParams.accounts || "",
    format: initialParams.format || "pdf",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch accounts
        const accountsResponse = await axios.get(
          "https://hms.backend.hiragroupcloud.com/api/account/account"
        );

        const accountsData = Array.isArray(accountsResponse.data)
          ? accountsResponse.data
          : accountsResponse.data.accounts || [];

        setAccounts(accountsData);

        // If cases are passed through state, use them
        if (initialParams.cases && initialParams.cases.length > 0) {
          setCases(initialParams.cases);
          setLoading(false);
          return;
        }

        // Fetch cases from backend
        const casesResponse = await axios.get(
          "https://hms.backend.hiragroupcloud.com/api/cases/cases"
        );

        let filteredCases = Array.isArray(casesResponse.data)
          ? casesResponse.data
          : [];

        // Apply account filter
        if (params.accounts) {
          filteredCases = filteredCases.filter(
            (c) => c.account_name === params.accounts
          );
        }

        // Apply date filter
        if (params.current_start_date && params.current_end_date) {
          const start = new Date(params.current_start_date);
          const end = new Date(params.current_end_date);

          end.setHours(23, 59, 59, 999);

          filteredCases = filteredCases.filter((c) => {
            const caseDate = new Date(c.date);
            return caseDate >= start && caseDate <= end;
          });
        }

        /*
         * If backend has data, use backend data.
         * If backend returns empty data, use temporary dummy data.
         */
        if (filteredCases.length > 0) {
          setCases(filteredCases);
        } else {
          setCases(dummyCases);
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);

        /*
         * If backend is not available yet,
         * keep/show temporary dummy data.
         */
        setCases(dummyCases);
        setLoading(false);
      }
    };

    fetchData();
  }, [params, initialParams.cases]);

  const handleParamChange = (newParams) => {
    setParams(newParams);
    setShowParam(false);
  };

  // Account click functionality
  const handleAccountClick = (accountName) => {
    if (!accountName) {
      console.warn("No account name provided for navigation");
      return;
    }

    const accountData = Array.isArray(accounts)
      ? accounts.find(
          (account) => account.account_name === accountName
        ) || {}
      : {};

    const caseItem = cases.find(
      (c) => c.account_name === accountName
    );

    navigate(`/tabsworking/${accountName || "unknown"}`, {
      state: {
        accountName: accountName || "Unknown Account",
        accountData,

        caseDetails: caseItem
          ? {
              caseId:
                caseItem.invoiceNumber ||
                caseItem.caseNumber,

              caseStatus: caseItem.status || "",
            }
          : {},
      },
    });
  };

  // Provider click functionality
  const handleProviderClick = (
    providerName,
    accountName
  ) => {
    if (!providerName) {
      console.warn("No provider name provided for navigation");
      return;
    }

    const caseItem = cases.find(
      (c) =>
        c.provider_name === providerName &&
        (!accountName ||
          c.account_name === accountName)
    );

    if (caseItem) {
      sessionStorage.setItem(
        "patientFullName",
        `${caseItem.first_name || ""} ${
          caseItem.last_name || ""
        }`.trim() || "Unknown Patient"
      );

      sessionStorage.setItem(
        "caseId",
        caseItem.invoiceNumber ||
          caseItem.caseNumber ||
          "unknown"
      );

      sessionStorage.setItem(
        "caseStatus",
        caseItem.status || ""
      );

      navigate(
        `/patientrecords/${
          caseItem.invoiceNumber ||
          caseItem.caseNumber ||
          "unknown"
        }`
      );
    } else {
      console.warn(
        "No case found for provider:",
        providerName
      );
    }
  };

  // Invoice click functionality
  const handleCaseInvoiceClick = (caseData) => {
    if (
      !caseData ||
      (!caseData.invoiceNumber &&
        !caseData.caseNumber)
    ) {
      console.warn(
        "No case data provided for navigation"
      );

      return;
    }

    navigate(
      `/invoices/${
        caseData.invoiceNumber ||
        caseData.caseNumber ||
        "unknown"
      }`,
      {
        state: {
          invoiceData: {
            ...caseData,

            invoiceNumber:
              caseData.invoiceNumber ||
              caseData.caseNumber,

            caseId:
              caseData.caseId ||
              caseData.invoiceNumber ||
              caseData.caseNumber,

            patient_name:
              `${caseData.first_name || ""} ${
                caseData.last_name || ""
              }`.trim(),

            invoiceDate: caseData.date,

            total: caseData.totalPrice || 0,

            subtotal: caseData.totalPrice || 0,

            taxes: 0,

            paid: 0,

            items: [
              {
                description: "Dental services",
                quantity: 1,
                amount: caseData.totalPrice || 0,
              },
            ],
          },
        },
      }
    );
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  const totalSales = cases.reduce(
    (sum, c) => sum + (Number(c.totalPrice) || 0),
    0
  );

  // Group cases by account
  const accountGroups = {};

  cases.forEach((c) => {
    const accountName =
      c.account_name || "Unknown Account";

    if (!accountGroups[accountName]) {
      accountGroups[accountName] = [];
    }

    accountGroups[accountName].push(c);
  });

  const details = [];

  Object.entries(accountGroups).forEach(
    ([accountName, accountCases]) => {
      // Account total row
      details.push({
        account: accountName,
        provider: "",
        item: "",
        date: "",

        sales: (
          <strong
            style={{
              color: "#111111",
              fontWeight: "700",
            }}
          >
            £
            {accountCases
              .reduce(
                (sum, c) =>
                  sum +
                  (Number(c.totalPrice) || 0),
                0
              )
              .toFixed(2)}
          </strong>
        ),
      });

      // Group by provider
      const providerGroups = {};

      accountCases.forEach((c) => {
        const providerName =
          c.provider_name || "Unknown Provider";

        if (!providerGroups[providerName]) {
          providerGroups[providerName] = [];
        }

        providerGroups[providerName].push(c);
      });

      Object.entries(providerGroups).forEach(
        ([providerName, providerCases]) => {
          // Provider total row
          details.push({
            account: "",
            provider: providerName,
            item: "",
            date: "",

            sales: (
              <strong
                style={{
                  color: "#111111",
                  fontWeight: "700",
                }}
              >
                £
                {providerCases
                  .reduce(
                    (sum, c) =>
                      sum +
                      (Number(c.totalPrice) || 0),
                    0
                  )
                  .toFixed(2)}
              </strong>
            ),
          });

          // Individual invoice rows
          providerCases.forEach((c) => {
            details.push({
              account: "",
              provider: "",

              item: (
                <span
                  onClick={() =>
                    handleCaseInvoiceClick(c)
                  }
                  style={{
                    cursor: "pointer",
                    color: "#004aad",
                    textDecoration: "none",
                  }}
                >
                  Case{" "}
                  {c.invoiceNumber ||
                    c.caseNumber ||
                    "Unknown"}{" "}
                  /{" "}
                  {c.last_name || "Unknown"}
                </span>
              ),

              date: c.date
                ? new Date(c.date)
                    .toISOString()
                    .split("T")[0]
                : "",

              sales: `£${(
                Number(c.totalPrice) || 0
              ).toFixed(2)}`,
            });
          });
        }
      );
    }
  );

  return (
    <>
      <Header />
      <Navvbar />

      {/* Main Report Container */}
      <div
        style={{
          width: "94%",
          marginLeft: "3%",
          marginRight: "3%",
          marginTop: "18px",
          padding: "0",
          boxSizing: "border-box",
        }}
      >
        {/* ================= TITLE ================= */}
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginBottom: "8px",
          }}
        >
          <h3
            style={{
              margin: "0",
              padding: "0",
              color: "#092c55",
              fontSize: "24px",
              fontWeight: "400",
              lineHeight: "1.3",
            }}
          >
            Account Sales{" "}
            {params.current_start_date} to{" "}
            {params.current_end_date}
          </h3>

          {/* Parameters */}
          <Link
            to="#"
            onClick={() =>
              setShowParam(!showParam)
            }
            style={{
              backgroundColor: "#004aad",
              color: "#ffffff",
              padding: "9px 16px",
              border: "none",
              borderRadius: "4px",
              fontSize: "14px",
              cursor: "pointer",
              height: "36px",
              minWidth: "114px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textDecoration: "none",
              boxSizing: "border-box",
              marginTop: "-3px",
            }}
          >
            ⚙ Parameters
          </Link>
        </div>

        {/* ================= PARAMETERS COMPONENT ================= */}
        {showParam && (
          <div
            id="addFile"
            style={{
              width: "100%",
              marginBottom: "20px",
            }}
          >
            <AccountSales
              initialParams={params}
              onParamChange={handleParamChange}
              details={details}
            />
          </div>
        )}

        {/* ================= SUMMARY ================= */}
        <div
          style={{
            width: "100%",
            borderBottom:
              "2px solid #003b78",
            marginTop: "8px",
            marginBottom: "0",
          }}
        >
          <h5
            style={{
              margin: "0 0 3px 0",
              padding: "0",
              color: "#1976c9",
              fontSize: "22px",
              fontWeight: "400",
              lineHeight: "1.2",
            }}
          >
            Summary
          </h5>
        </div>

        {/* Summary Header */}
        <div
          style={{
            width: "100%",
            backgroundColor: "#eeeeee",
            minHeight: "78px",
            boxSizing: "border-box",
            margin: "0",
            padding: "0 10px",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              minHeight: "76px",
            }}
          >
            <strong
              style={{
                fontSize: "16px",
                color: "#111111",
                fontWeight: "700",
                marginRight: "4px",
              }}
            >
              Sales
            </strong>
          </div>
        </div>

        {/* Summary Amount */}
        <div
          style={{
            width: "100%",
            minHeight: "26px",
            backgroundColor: "#eeeeee",
            borderRadius:
              "0 0 3px 3px",
            marginTop: "7px",
            marginBottom: "14px",
            padding: "0 4px",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "26px",
              backgroundColor: "#ffffff",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              color: "#444444",
              fontSize: "15px",
              paddingRight: "3px",
              boxSizing: "border-box",
            }}
          >
            £{totalSales.toFixed(2)}
          </div>
        </div>

        {/* ================= DETAILS ================= */}
        <div
          style={{
            width: "100%",
            borderBottom:
              "2px solid #003b78",
            marginTop: "0",
            marginBottom: "0",
          }}
        >
          <h5
            style={{
              margin: "0 0 3px 0",
              padding: "0",
              color: "#1976c9",
              fontSize: "22px",
              fontWeight: "400",
              lineHeight: "1.2",
            }}
          >
            Details
          </h5>
        </div>

        {/* Details Table */}
        <div
          style={{
            width: "100%",
            overflowX: "auto",
            margin: "0",
            padding: "0",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              tableLayout: "fixed",
              margin: "0",
              fontSize: "15px",
              color: "#334455",
            }}
          >
            <thead>
              <tr
                style={{
                  backgroundColor: "#eeeeee",
                }}
              >
                <th
                  style={{
                    width: "39%",
                    textAlign: "left",
                    padding: "18px 14px",
                    fontWeight: "700",
                    color: "#111111",
                    borderBottom:
                      "1px solid #d2d2d2",
                  }}
                >
                  Account
                </th>

                <th
                  style={{
                    width: "19%",
                    textAlign: "left",
                    padding: "18px 14px",
                    fontWeight: "700",
                    color: "#111111",
                    borderBottom:
                      "1px solid #d2d2d2",
                  }}
                >
                  Provider
                </th>

                <th
                  style={{
                    width: "20%",
                    textAlign: "left",
                    padding: "18px 14px",
                    fontWeight: "700",
                    color: "#111111",
                    borderBottom:
                      "1px solid #d2d2d2",
                  }}
                >
                  Item
                </th>

                <th
                  style={{
                    width: "10%",
                    textAlign: "left",
                    padding: "18px 14px",
                    fontWeight: "700",
                    color: "#111111",
                    borderBottom:
                      "1px solid #d2d2d2",
                  }}
                >
                  Date
                </th>

                <th
                  style={{
                    width: "12%",
                    textAlign: "right",
                    padding: "18px 14px",
                    fontWeight: "700",
                    color: "#111111",
                    borderBottom:
                      "1px solid #d2d2d2",
                  }}
                >
                  Sales
                </th>
              </tr>
            </thead>

            <tbody>
              {details.map(
                (detail, index) => (
                  <tr
                    key={index}
                    style={{
                      borderBottom:
                        "2px solid #d8d8d8",
                      backgroundColor:
                        "#ffffff",
                    }}
                  >
                    {/* Account */}
                    <td
                      onClick={
                        detail.account
                          ? () =>
                              handleAccountClick(
                                detail.account
                              )
                          : undefined
                      }
                      style={{
                        padding:
                          "6px 4px",
                        verticalAlign:
                          "top",
                        color:
                          detail.account
                            ? "#004aad"
                            : "#334455",
                        fontWeight:
                          detail.account
                            ? "700"
                            : "400",
                        cursor:
                          detail.account
                            ? "pointer"
                            : "default",
                        lineHeight:
                          "1.35",
                        wordBreak:
                          "break-word",
                      }}
                    >
                      {detail.account}
                    </td>

                    {/* Provider */}
                    <td
                      onClick={
                        detail.provider
                          ? () =>
                              handleProviderClick(
                                detail.provider,
                                detail.account
                              )
                          : undefined
                      }
                      style={{
                        padding:
                          "6px 4px",
                        verticalAlign:
                          "top",
                        color:
                          detail.provider
                            ? "#004aad"
                            : "#334455",
                        cursor:
                          detail.provider
                            ? "pointer"
                            : "default",
                        lineHeight:
                          "1.35",
                        wordBreak:
                          "break-word",
                      }}
                    >
                      {detail.provider}
                    </td>

                    {/* Item */}
                    <td
                      style={{
                        padding:
                          "6px 4px",
                        verticalAlign:
                          "top",
                        color: "#004aad",
                        lineHeight:
                          "1.35",
                        wordBreak:
                          "break-word",
                      }}
                    >
                      {detail.item}
                    </td>

                    {/* Date */}
                    <td
                      style={{
                        padding:
                          "6px 4px",
                        verticalAlign:
                          "top",
                        color: "#334455",
                        lineHeight:
                          "1.35",
                      }}
                    >
                      {detail.date}
                    </td>

                    {/* Sales */}
                    <td
                      style={{
                        padding:
                          "6px 4px",
                        verticalAlign:
                          "top",
                        textAlign:
                          "right",
                        color: "#333333",
                        lineHeight:
                          "1.35",
                        whiteSpace:
                          "nowrap",
                      }}
                    >
                      {detail.sales}
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </div>

      <br />
      <br />
      <br />
    </>
  );
};

export default Addaccountsales;